
import classes from './about.module.css';
import data from '../../assest/skill/data.svg';
import database from '../../assest/skill/database-.svg';
import web from '../../assest/skill/web.svg';
import cp from '../../assest/skill/cp.png';
import { addScaleCorrection, motion } from "framer-motion";
let state = [
  { 
    icon:data,
    title:"Data Structure and Algorithm",
    id:"1"
  },
  { 
    icon:cp,
    title:"Competitive Programming",
    id:"2"
  },
  { 
    icon:web,
    title:"MERN Stack",
    id:"3"
  },
  { 
    icon:data,
    title:"Database",
    id:"4"
  }

]




const about = ()=>{
  const ani1 = {
    hidden:{
        y:'8vh',
        opacity:0
    },
    visible:{
        y:0,
        opacity:1,
        transition:{
            delay:0.2,duration:0.6,type:'spring'
        }
        ,
                exit:{
                    opacity:0,
                    transition:{
                        ease:'easeInOut'
                    }
                }
                
        
  
    }
  }
    const c1 = ["container",classes.about_skill];
    const c2 = ["col-sm-12 col-md-6",classes.card];
    let skill  = state.map(s=>{
        return (
            <div key ={s.id} className={c2.join(' ')}>
                 <img  src={s.icon} alt="icon" style={{width:"50%",height:"50%"}} />
        <h3 style={{color:"white"}}>{s.title}</h3>
                  

            </div>
        )
    })
    return(
        <motion.div classsName={classes.about}
        variants={ani1}
        initial='hidden'
        animate='visible'
        exit='exit'
        >
            <h6 className="mt-3"> 
            A Computer Science UnderGraduate with huge intrest in Problem Solving ,DataStructure And Algorithm ,Database ,and Web Develoopment.
            Currently, I am Pursuing B-Tech in ComputerScience And Engenering from Madan Mohan Malaviya University Of Technolgy,Gorakhpur.

            </h6>
            <div className={c1.join(' ')}>
                <h5 className={classes.intro}>Interest</h5>
                <div className="row">
                    {
                         skill
                    }

                </div>

            </div>
        
            
        </motion.div>
    )
}
export default about;